// extracted by mini-css-extract-plugin
module.exports = {"marker":"MultiMarker-module__marker___2QFF2","markerSelected":"MultiMarker-module__markerSelected___1bkzj","triangle":"MultiMarker-module__triangle___3kNI8"};